import { render, staticRenderFns } from "./CallpopOrgView.vue?vue&type=template&id=6b340d34&scoped=true"
import script from "./CallpopOrgView.vue?vue&type=script&lang=js"
export * from "./CallpopOrgView.vue?vue&type=script&lang=js"
import style0 from "./CallpopOrgView.vue?vue&type=style&index=0&id=6b340d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b340d34",
  null
  
)

export default component.exports